import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import {debounceTime, distinctUntilChanged, map} from 'rxjs/operators';
import {BreakpointObserver, Breakpoints, BreakpointState} from '@angular/cdk/layout';

@Injectable({
  providedIn: 'root'
})
export class CoreMediaService {
  currentMediaQuery: string;
  onMediaUpdate: BehaviorSubject<string> = new BehaviorSubject<string>('');

  private breakpointsToObserve = [
    Breakpoints.XSmall,
    Breakpoints.Small,
    Breakpoints.Medium,
    Breakpoints.Large,
    Breakpoints.XLarge
  ];

  private breakpointAliasMap: { [key: string]: string } = {
    [Breakpoints.XSmall]: 'xs',
    [Breakpoints.Small]: 'sm',
    [Breakpoints.Medium]: 'md',
    [Breakpoints.Large]: 'lg',
    [Breakpoints.XLarge]: 'xl'
  };

  /**
   * Constructor
   *
   * @param {BreakpointObserver} _breakpointObserver
   */
  constructor(private _breakpointObserver: BreakpointObserver) {
    // Set the defaults
    this.currentMediaQuery = '';

    // Initialize
    this._init();
  }

  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Initialize
   *
   * @private
   */
  private _init(): void {
    /*
    this._breakpointObserver.asObservable().pipe(debounceTime(500), distinctUntilChanged()).subscribe((changes: MediaChange[]) => {
      const change = changes[0];
      if (this.currentMediaQuery !== change.mqAlias) {
        this.currentMediaQuery = change.mqAlias;
        this.onMediaUpdate.next(change.mqAlias);
      }
    });
     */
    this._breakpointObserver
      .observe(this.breakpointsToObserve)
      .pipe(
        debounceTime(500),
        map((state: BreakpointState) => {
          for (const query in state.breakpoints) {
            if (state.breakpoints[query]) {
              return this.breakpointAliasMap[query] || 'unknown';
            }
          }
          return 'unknown'; // Fallback if no breakpoint matches (unlikely)
        }),
        distinctUntilChanged()
      )
      .subscribe((alias: string) => {
        if (this.currentMediaQuery !== alias) {
          this.currentMediaQuery = alias;
          this.onMediaUpdate.next(alias);
        }
      });
  }
}
